document.addEventListener('DOMContentLoaded', () => {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.15
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('opacity-100', 'translate-y-0');
        entry.target.classList.remove('opacity-0', 'translate-y-10');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  const fadeUpElements = document.querySelectorAll('.gs-fade-up');
  fadeUpElements.forEach(el => {
    el.classList.add('transition-all', 'duration-700', 'ease-out', 'opacity-0', 'translate-y-10');
    observer.observe(el);
  });
  
  // Parallax effect for product image
  const parallaxImg = document.querySelector('.gs-parallax-img');
  if (parallaxImg) {
    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      parallaxImg.style.transform = `translateY(${scrollY * 0.3}px) scale(${1 + scrollY * 0.0002})`;
    });
  }

  // Horizontal Scroll effect for gallery
  const horizontalTrigger = document.getElementById('horizontal-gallery-trigger');
  const horizontalPanel = document.getElementById('horizontal-gallery-panel');
  if (horizontalTrigger && horizontalPanel) {
    window.addEventListener('scroll', () => {
      const rect = horizontalTrigger.getBoundingClientRect();
      const panelCount = parseInt(horizontalTrigger.dataset.panelCount || "3", 10);
      const maxTranslate = ((panelCount - 1) / panelCount) * 100;
      
      // If the trigger is pinned at the top
      if (rect.top <= 0 && rect.bottom >= window.innerHeight) {
        const scrollProgress = Math.abs(rect.top) / (rect.height - window.innerHeight);
        horizontalPanel.style.transform = `translateX(-${scrollProgress * maxTranslate}%)`;
      } else if (rect.top > 0) {
        horizontalPanel.style.transform = `translateX(0%)`;
      } else if (rect.bottom < window.innerHeight) {
        horizontalPanel.style.transform = `translateX(-${maxTranslate}%)`;
      }
    });
  }
});
